import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={`${size}px`}
    height={`${size}px`}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    fill="none"
    {...props}
  >
    <path
      stroke={color}
      strokeLinejoin="round"
      strokeWidth="2"
      d="m12 20-5-7c-2.5-4 .606-9 5-9s7.5 5 5 9l-5 7Z"
      clipRule="evenodd"
    />
    <circle cx="12" cy="10" r="2" stroke={color} strokeWidth="2" />
  </svg>
);
